const LOCAL_DEV_API_ORIGIN = 'http://localhost:3008';

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');
const isLocalAddress = (value: string): boolean => /(^|\/\/)(localhost|127\.0\.0\.1)(:|\/|$)/i.test(value);

const readConfiguredApiOrigin = (): string => {
  const raw = (process.env.REACT_APP_API_URL || '').trim();
  if (!raw) {
    return '';
  }

  // 避免生产环境构建时误用 .env.local 的 localhost 配置
  if (process.env.NODE_ENV === 'production' && isLocalAddress(raw)) {
    return '';
  }

  if (/^https?:\/\//i.test(raw)) {
    return trimTrailingSlash(raw);
  }

  if (raw.startsWith('/')) {
    if (typeof window !== 'undefined' && window.location?.origin) {
      return trimTrailingSlash(`${window.location.origin}${raw}`);
    }
    return trimTrailingSlash(raw);
  }

  return trimTrailingSlash(`https://${raw}`);
};

export const getApiOrigin = (): string => {
  const configured = readConfiguredApiOrigin();
  if (configured) {
    return configured;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }

  return LOCAL_DEV_API_ORIGIN;
};

export const getApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiOrigin()}${normalizedPath}`;
};

export const API_BASE_URL = `${getApiOrigin()}/api`;
